import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsCaptchaComponent} from '../../common/sts-captcha/sts-captcha.component';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import {StsNotificationType} from '../../../models/sts-notification-type';
import { StsCaptcha } from 'app/models/sts-captcha.model';

@Component({
  selector: 'app-account-verify-employer-code',
  templateUrl: './account-verify-employer-code.component.html',
  styleUrls: ['./account-verify-employer-code.component.scss']
})
export class AccountVerifyEmployerCodeComponent implements OnInit {

  @ViewChild(StsCaptchaComponent) captcha: StsCaptchaComponent;
  public empForm: FormGroup;
  public errors: StsNotification[] = [];
  protected id: string;
  protected key: string;
  public hasErrors: boolean;
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public fb: FormBuilder,
    private regService: StsA360RegServicesService,
    private tntInfo: StsTenantService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    this.empForm = this.fb.group({

      code: new FormControl('', { validators: [
        Validators.required,
        Validators.pattern('[A-Za-z0-9-]+')
      ], updateOn: 'blur'})

    });

    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.key = params['secret'];
    });


  }

  ngOnInit() {
  }

  onSubmit(captcha: StsCaptcha): void {
    this.errors = [];

    if (captcha) {
      let rsp = this.captcha.checkForCaptchaError(captcha);
      if (rsp != null) {
        this.errors.push(rsp);
        this.captcha.reset();
        return;
      }
    }

    this.submitter.emit(false);
    this.triggerValidation('');

    if (!this.hasErrors) {
      this.submitter.emit(true);
      this.regService.postEmployerValidationLoad(
        this.id,
        this.key,
        this.empForm.controls['code'].value,
        captcha
      ).subscribe(a => {
        this.submitter.emit(false);
        if (a.success) {
          this.router.navigateByUrl('/account/password/new');
        } else {
          this.captcha.reset();
          let n = new StsNotification();
          n.level = StsNotificationType.Error;
          n.code = a.stsCode || a['sts-code'];
          n.description = a.message;
          this.errors.push(n);
        }
      },
      errorRsp => {
        this.captcha.reset();
        let err = new StsNotification();
        err.code = errorRsp.stsCode || 'sts-reset-pass-message';
        err.description = errorRsp.message || errorRsp.stsCode || 'Error';
        err.level = StsNotificationType.Error;
        this.errors.push(err);
      });
    } else {
      this.captcha.reset();
      let n = new StsNotification();
      n.level = StsNotificationType.Error;
      n.code = 'sts-please-fix-errors';
      n.description = 'Please correct all of the errors.';
      this.errors.push(n);
      this.submitter.emit(false);
    }
  }


  gotoHome(): void {
    this.router.navigateByUrl('/');
  }


  public triggerValidation(v) {
    this.hasErrors = !this.empForm.valid;
    this.empForm.controls['code'].updateValueAndValidity();
  }
}
